import { Box, CircularProgress, Typography } from '@mui/material'

// Dims whatever it's layered over with a large, centered spinner. Meant to be
// dropped inside a `position: relative` container. Each independently-loading
// unit (a chart card, the aggregation table, ...) gets its OWN instance,
// gated on THAT unit's own loading flag — Performance's charts (one fetch,
// GetDashboardSeries) and its table (a separate fetch, GetAggregationTable)
// load independently of one another, so one shared/page-wide overlay would
// either dim things that aren't actually reloading, or miss a reload that IS
// happening elsewhere on the page.
//
// Extracted into its own file (rather than living in whichever component
// used it first) specifically so both Beacon4PerformanceView.jsx and
// Beacon4PerformanceAggregationTable.jsx can import it without either one
// importing from the other — Beacon4PerformanceView already imports the
// table component, so the table importing anything back FROM
// Beacon4PerformanceView would be a circular import.
export default function LoadingOverlay({ radius = '12px' }) {
  return (
    <Box sx={{
      position: 'absolute', inset: 0, zIndex: 5,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1,
      bgcolor: 'rgba(255,255,255,0.7)', borderRadius: radius,
    }}>
      <CircularProgress size={32} thickness={4} />
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}>Loading…</Typography>
    </Box>
  )
}